import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import { createTemp, updateTemp } from "@/api/temp";
export default {
  name: "tempComp",
  props: {
    form: Object,
    temp_type: Number,
    temp_id: Number,
    old_temp_name: String
  },
  data: function data() {
    return {
      temp_name: this.temp_id !== 0 ? this.old_temp_name : ""
    };
  },
  created: function created() {
    console.log(this.temp_id, this.old_temp_name);
  },
  methods: {
    tempBtn: function tempBtn() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data, res, _res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              data = {
                temp_content: _this.form,
                temp_name: _this.temp_name,
                temp_desc: "默认不要",
                temp_type: _this.temp_type
              };
              if (_this.temp_name) {
                _context.next = 5;
                break;
              }
              _this.$message({
                type: "warning",
                message: "必须填写模板名称"
              });
              _context.next = 17;
              break;
            case 5:
              if (!_this.temp_id) {
                _context.next = 13;
                break;
              }
              data.id = _this.temp_id;
              _context.next = 9;
              return updateTemp(data);
            case 9:
              res = _context.sent;
              if (res.code == 0) {
                _this.$emit("backTemp", res.data.id);
                _this.$message({
                  type: "success",
                  message: "保存当前模板成功"
                });
              }
              _context.next = 17;
              break;
            case 13:
              _context.next = 15;
              return createTemp(data);
            case 15:
              _res = _context.sent;
              if (_res.code == 0) {
                _this.$emit("backTemp", _res.data.id);
                _this.$message({
                  type: "success",
                  message: "保存当前模板成功"
                });
              }
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};